<template>
    <div class="container">
        <div class="row mb-1">
            <div class="col-sm text-start pb-1">
                <span class="badge rounded-pill pull-left mt-1 py-2 px-4 bg-primary" style="font-size:18px;">
                        <b>Work Sheet : ใบรับเข้าห้องแล็บ</b>
                </span>
                <div class="form-check form-check-inline ms-5 p-2" title="All Type">
                  <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="1" v-model="TestType">
                  <label class="form-check-label" for="inlineRadio1">All</label>
                </div>
                <div class="form-check form-check-inline ms-4 p-2" title="SARS-CoV-2">
                  <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="2" v-model="TestType">
                  <label class="form-check-label" for="inlineRadio2">RT-PCR</label>
                </div>
                <div class="form-check form-check-inline ms-4 p-2" title="ATK Rapid Test">
                  <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio3" value="3" v-model="TestType">
                  <label class="form-check-label" for="inlineRadio3">ATK</label>
                </div>
            </div> {{TestType}}
        </div>
        <p class="text-start text-black-50 ms-2">Work Sheet : แสดงรายการสั่งตรวจ เรียงตามลำดับการรับเข้าห้องแล็บในแต่ละรอบ</p>
        <div class="row">
            <div class="col-sm-3">
                <!-- รอบนำส่ง Specimen 1, 2, ... 9 -->
                <div class="input-group input-group-sm">
                    <span class="input-group-text">รอบรับที่ *</span>
                    <select class="form-select form-select-sm" ref="ReceivedRound" @change="getData()"
                    id="ReceivedRound" name="ReceivedRound" v-model="ReceivedRound" >
                        <option disabled value="">Please select one</option>
                        <option v-for="item in [1,2,3,4,5,6,7,8,9]" :key="item" :value="item">{{ item }}</option>
                    </select>
                </div>
            </div>
            <div class="col-sm-4">
                <!-- วันที่ใบสั่งตรวจ -->
                <div class="input-group input-group-sm">
                    <span class="input-group-text">วันที่รับเข้าห้องแล็บ *</span>
                    <v-date-picker :masks="masks" mode="date" v-model="dateFm" >
                        <template v-slot="{ inputValue, inputEvents }">
                            <input name="dateFm" ref="DateFm" style="width:200px;;"
                            class="bg-white border px-2 py-1 rounded"
                            :value="inputValue"
                            v-on="inputEvents"
                            />
                        </template>
                    </v-date-picker>
                </div>
            </div>
            <div class="col text-start">
                <button type="button" class="btn btn-info btn-sm text-white mx-2" @click="btnGetWorkSheet_Clicked()">ดึงข้อมูลใบ Work Sheet</button>
            </div>
        </div>

        <br>
        <div class="container">
            <button class="btn btn-outline-primary mx-1 mb-2 float-start" title="พิมพ์ใบ Work Sheet รูปแบบตามเงื่อนไขประเภทการตรวจข้างต้น"
             @click="btnPrintWorkSheet_Clicked()" v-if="dataLists!==null"><i class="fa fa-print"></i> Work Sheet</button>
            <!-- RT-PCR WorkSheet -->
            <div id="divToPrint" class="container-fluid">
                <table id="myLabReqTable" data-pdfmake="{'headerRows': 1}"
                  class="table table-sm table-hover table-striped table-bordered" style="width: 100%;">
                    <thead>
                    <tr class="bg-dark text-white" style="text-align:center;">
                        <th style="width:30px;">No.</th>
                        <th style="width:100px;">LN</th>
                        <th style="width:180px;">Name</th>
                        <th style="width:180px;">Barcode</th>
                        <th style="width:120px;">Lab result</th>
                        <th style="width:120px;">ORF-1ab gene</th>
                        <th style="width:70px;">N gene</th>
                        <th style="width:70px;">IC gene</th>
                        <th style="width:90px;">หมายเหตุ</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, index) in dataLists" :key="item.ROID" v-bind:data-id="item.ROID" >
                        <td class="text-center" >{{ index + 1 }}.</td>
                        <td class="text-center" >{{ item.RONo }}</td>
                        <td class="text-start" >{{ item.PatName }} {{ item.PatLName}}</td>
                        <td class=""><img :src="textToBase64Barcode(item.RONo)" alt="Red dot" style="width:180px;height:60px;" /> </td>
                        <td class=""></td>
                        <td class=""></td>
                        <td class=""></td>
                        <td class=""></td>
                        <td class=""></td>
                    </tr>
                    <tr >
                        <td class="text-center"></td>
                        <td class="text-center">****</td>
                        <td class="text-start">Negative Control</td>
                        <td class=""></td>
                        <td class=""></td>
                        <td class=""></td>
                        <td class=""></td>
                        <td class=""></td>
                        <td class=""></td>
                    </tr>
                    <tr >
                        <td class="text-center"></td>
                        <td class="text-center">****</td>
                        <td class="text-start">Positive Control</td>
                        <td class=""></td>
                        <td class=""></td>
                        <td class=""></td>
                        <td class=""></td>
                        <td class=""></td>
                        <td class=""></td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <!-- ATK WorkSheet -->
            <div id="divToPrintATK" class="container-fluid" hidden>
                <table id="myLabReqTable" data-pdfmake="{'headerRows': 1}"
                  class="table table-sm table-hover table-striped table-bordered" style="width: 100%;">
                    <thead>
                    <tr class="bg-dark text-white" style="text-align:center;">
                        <th style="width:30px;">No.</th>
                        <th style="width:100px;">LN</th>
                        <th style="width:180px;">Name</th>
                        <th style="width:180px;">Barcode</th>
                        <th style="width:120px;">Lab result</th>
                        <th style="width:90px;">หมายเหตุ</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, index) in dataLists" :key="item.ROID" v-bind:data-id="item.ROID" >
                        <td class="text-center" >{{ index + 1 }}.</td>
                        <td class="text-center" >{{ item.RONo }}</td>
                        <td class="text-start" >{{ item.PatName }} {{ item.PatLName}}</td>
                        <td class=""><img :src="textToBase64Barcode(item.RONo)" alt="Red dot" style="width:180px;height:60px;" /> </td>
                        <td class=""></td>
                        <td class=""></td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
// import axios from 'axios'
import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
import 'bootstrap/dist/css/bootstrap.min.css'
import 'jquery/dist/jquery.min.js'
// Datatable Modules
import 'datatables.net-dt/js/dataTables.dataTables'
import 'datatables.net-dt/css/jquery.dataTables.min.css'
// import $ from 'jquery'
import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

import JsBarcode from 'jsbarcode/bin/JsBarcode'
import pdfMake from 'pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import htmlToPdfmake from 'html-to-pdfmake'
pdfMake.vfs = pdfFonts.pdfMake.vfs
// // ต้องระบุตามชื่อของ ไฟล์ font
pdfMake.fonts = {
  THSarabunNew: {
    normal: 'THSarabunNew.ttf',
    bold: 'THSarabunNew-Bold.ttf',
    italics: 'THSarabunNew-Italic.ttf',
    bolditalics: 'THSarabunNew-BoldItalic.ttf'
  },
  Roboto: {
    normal: 'Roboto-Regular.ttf',
    bold: 'Roboto-Medium.ttf',
    italics: 'Roboto-Italic.ttf',
    bolditalics: 'Roboto-MediumItalic.ttf'
  }
}

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition
    }
  },
  name: 'LabWorkSheet',
  data () {
    return {
      masks: {
        input: 'YYYY-MM-DD'
      },
      arrSex: ['', 'ชาย', 'หญิง'],
      arrDocStatus: ['New', 'Lab', 'Resulted', 'AP'],
      arrPayType: ['เงินสด', 'เครดิต'],
      // เงื่อนไขสำหรับออกรายงานสรุปใบนำส่ง
      dataLists: [],
      ReceivedRound: 1,
      // เงื่อนไขสำหรับดึงข้อมูลหน้าหลัก
      dateFm: new Date(),
      TestType: 1, // 1-All  2-RT PCR  3-ATK
      // รายชื่อสาขาทั้งหมด สำหรับเลือกใน Header Table
      dataBranchlists: null
    }
  },
  mounted () {

  },
  components: {

  },
  methods: {
    btnPrintWorkSheet_Clicked () {
      console.log(this.TestType)
      console.log(this.TestType === '1')
      console.log(this.TestType === '2')
      console.log(this.TestType === '3')
      if (this.TestType === '1' || this.TestType === '2' ||
          this.TestType === 1 || this.TestType === 2) {
        this.createPdfWorkSheetToScreenRTPCR()
      } else if (this.TestType === '3' || this.TestType === 3) {
        this.createPdfWorkSheetToScreenATK()
      } else {
        this.createPdfWorkSheetToScreenRTPCR()
      }
      // this.createPdfWorkSheetToScreenATK()
    },
    createPdfWorkSheetToScreenATK () {
      var d = this.dateFm
      var YYYY = d.getFullYear().toString()
      var MM = ''
      var DD = ''
      if (d.getMonth() + 1 < 10) {
        MM = '0' + (d.getMonth() + 1).toString()
      } else {
        MM = (d.getMonth() + 1).toString()
      }
      if (d.getDate() < 10) {
        DD = '0' + d.getDate().toString()
      } else {
        DD = d.getDate().toString()
      }
      var docDateRcv = YYYY + '-' + MM + '-' + DD
      // var self = this
      // -------- get table html
      const pdfTable = document.getElementById('divToPrintATK')
      // ------- html to pdf format
      var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })
      console.log(html)
      var documentDefinition = {
        pageSize: 'A4',
        pageOrientation: 'landscape',
        pageMargins: [10, 100, 10, 60],
        header: [
          {
            text: 'แบบบันทึกการเก็บตัวอย่างและผลการตรวจวิเคราะห์ทางห้องปฏิบัติการ เอ็มไอทีเซนเตอร์คลินิกเทคนิคการแพทย์',
            alignment: 'center',
            fontSize: 18,
            bold: true,
            margin: [0, 20, 0, 0]
          },
          {
            text: 'วันที่รับเข้าห้องแล็บ ' + docDateRcv + ' / รอบรับเข้าที่ ' + this.ReceivedRound,
            alignment: 'center',
            fontSize: 18,
            bold: false,
            margin: [0, 0, 0, 0]
          }
        ],
        footer: function (currentPage, pageCount) {
          return {
            text: currentPage.toString() + ' of ' + pageCount,
            alignment: 'center'
          }
        },
        content: html,
        style: {

        },
        defaultStyle: {
          // font: 'Roboto'
          font: 'THSarabunNew',
          fontSize: 18
        }
      }
      // pdfMake.vfs = pdfFonts.pdfMake.vfs
      pdfMake.createPdf(documentDefinition, 'lightHorizontalLines').open()
      // pdfMake.createPdf(documentDefinition).download()
      // pdfMake.createPdf(documentDefinition).print()
    },
    createPdfWorkSheetToScreenRTPCR () {
      var d = this.dateFm
      var YYYY = d.getFullYear().toString()
      var MM = ''
      var DD = ''
      if (d.getMonth() + 1 < 10) {
        MM = '0' + (d.getMonth() + 1).toString()
      } else {
        MM = (d.getMonth() + 1).toString()
      }
      if (d.getDate() < 10) {
        DD = '0' + d.getDate().toString()
      } else {
        DD = d.getDate().toString()
      }
      var docDateRcv = YYYY + '-' + MM + '-' + DD
      // var self = this
      // -------- get table html
      const pdfTable = document.getElementById('divToPrint')
      // ------- html to pdf format
      var html = htmlToPdfmake(pdfTable.innerHTML, { tableAutoSize: true })
      console.log(html)
      var documentDefinition = {
        pageSize: 'A4',
        pageOrientation: 'landscape',
        pageMargins: [10, 100, 10, 60],
        header: [
          {
            text: 'แบบบันทึกการเก็บตัวอย่างและผลการตรวจวิเคราะห์ทางห้องปฏิบัติการ เอ็มไอทีเซนเตอร์คลินิกเทคนิคการแพทย์',
            alignment: 'center',
            fontSize: 18,
            bold: true,
            margin: [0, 20, 0, 0]
          },
          {
            text: 'วันที่รับเข้าห้องแล็บ ' + docDateRcv + ' / รอบรับเข้าที่ ' + this.ReceivedRound,
            alignment: 'center',
            fontSize: 18,
            bold: false,
            margin: [0, 0, 0, 0]
          }
        ],
        footer: function (currentPage, pageCount) {
          return {
            text: currentPage.toString() + ' of ' + pageCount,
            alignment: 'center'
          }
        },
        content: html,
        style: {

        },
        defaultStyle: {
          // font: 'Roboto'
          font: 'THSarabunNew',
          fontSize: 18
        }
      }
      // pdfMake.vfs = pdfFonts.pdfMake.vfs
      pdfMake.createPdf(documentDefinition, 'lightHorizontalLines').open()
      // pdfMake.createPdf(documentDefinition).download()
      // pdfMake.createPdf(documentDefinition).print()
    },
    textToBase64Barcode (text) {
      var canvas = document.createElement('canvas')
      // var canvas = document.getElementById('2108-000008')
      JsBarcode(canvas, text, { width: 4, height: 70 })
      var canvasDataURL = canvas.toDataURL('image/png')
      return canvasDataURL
    },
    btnGetWorkSheet_Clicked () {
      if (!(this.ReceivedRound > 0)) {
        this.$refs.ReceivedRound.focus()
        Swal.fire({ position: 'top-end', icon: 'warning', text: 'กรุณาระบุ "รอบนำส่ง ', showConfirmButton: false, timer: 1500 })
        return false
      }
      if ((this.dateFm === null)) {
        this.$refs.DateFm.focus()
        Swal.fire({ position: 'top-end', icon: 'warning', text: 'กรุณาระบุ "วันที่รับเข้าห้องแล็บ"', showConfirmButton: false, timer: 1500 })
        return false
      }
      this.getWorkSheetData()
    },
    getWorkSheetData () {
      var d = this.dateFm
      var YYYY = d.getFullYear().toString()
      var MM = ''
      var DD = ''
      if (d.getMonth() + 1 < 10) {
        MM = '0' + (d.getMonth() + 1).toString()
      } else {
        MM = (d.getMonth() + 1).toString()
      }
      if (d.getDate() < 10) {
        DD = '0' + d.getDate().toString()
      } else {
        DD = d.getDate().toString()
      }
      var docDate = YYYY + '-' + MM + '-' + DD
      // MyApiClient.get('getdata/labrequest_all.php')
      MyApiClient.get('getdata/labrequest_work_sheet.php?C1=' + this.globalCorpID + '&ReceivedRound=' + this.ReceivedRound +
        '&ReceivedDate=' + docDate + '&TestType=' + this.TestType)
        .then((resp) => {
          // console.log(resp.data.response)
          this.dataLists = resp.data.response
          if (this.dataLists == null) {
            Swal.fire({ icon: 'info', text: 'ไม่มีข้อมูล', showConfirmButton: false, timer: 1000 })
          }
          // this.createPdfROEodToScreen()
        })
        .catch((err) => {
          console.log(err.response)
        })
    }
  }
}
</script>

<style>

</style>
